import { NavLink } from 'react-router-dom';
import { cn } from '../../lib/utils';

export interface TabItem {
  to: string;
  label: string;
  end?: boolean;
}

/** Router-driven sub-navigation tabs. */
export function NavTabs({ items }: { items: TabItem[] }) {
  return (
    <div className="mb-6 flex flex-wrap gap-1 border-b border-gray-200 dark:border-gray-800"> {/* dark: ADDED FOR THEME */}
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              '-mb-px border-b-2 px-4 py-2.5 text-sm font-medium transition-colors',
              isActive
                ? 'border-blue-600 text-blue-600 dark:border-blue-400 dark:text-blue-400'
                : 'border-transparent text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-100',
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
}
